import React, { useContext } from "react";
import * as Contexts from "../../../../contexts";
import { Translater } from "../../../../config";
import { TextAreaWrap, Wrapper } from "./styled";
import { Controller, useFormContext } from "react-hook-form";
import { TBanquetForm } from "../../types";
import Input from "../../../../components/Form/Input";

export const Descriptions = () => {
  const { language } = useContext(Contexts.LanguageContext);
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext<TBanquetForm>();

  return (
    <Wrapper>
      <TextAreaWrap>
        <p className="label">
          {`${Translater?.Landings?.Banquet?.description[language?.slug]} UK`}
        </p>
        <textarea
          name="descriptionUk"
          ref={register({
            required:
              Translater?.Landings?.Banquet?.required?.[language?.slug] ||
              "Required field",
          })}
        />
        {errors?.descriptionUk?.message && (
          <span>{errors.descriptionUk.message.toString()}</span>
        )}
      </TextAreaWrap>{" "}
      <TextAreaWrap>
        <p className="label">
          {`${Translater?.Landings?.Banquet?.description[language?.slug]} EN`}
        </p>
        <textarea
          name="descriptionEn"
          ref={register({
            required:
              Translater?.Landings?.Banquet?.required?.[language?.slug] ||
              "Required field",
          })}
        />
        {errors?.descriptionEn?.message && (
          <span>{errors.descriptionEn.message.toString()}</span>
        )}
      </TextAreaWrap>
      <TextAreaWrap>
        <p className="label">
          {Translater?.Landings?.Banquet?.phoneNumber[language?.slug]}
        </p>
        <Controller
          defaultValue=""
          rules={{
            required: Translater?.Landings?.Banquet?.required?.[language?.slug],
          }}
          control={control}
          name="phone"
          render={({ value, onChange }) => (
            <Input value={value} inputHandler={onChange} name="" />
          )}
        />
        {errors?.phone?.message && (
          <span>{errors.phone.message.toString()}</span>
        )}
      </TextAreaWrap>
    </Wrapper>
  );
};
